var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 8H11.625L9.75 10.25H7.5C7.10218 10.25 6.72064 10.408 6.43934 10.6893C6.15804 10.9706 6 11.3522 6 11.75V18.5C6 18.8978 6.15804 19.2794 6.43934 19.5607C6.72064 19.842 7.10218 20 7.5 20H19.5C19.8978 20 20.2794 19.842 20.5607 19.5607C20.842 19.2794 21 18.8978 21 18.5V11.75C21 11.3522 20.842 10.9706 20.5607 10.6893C20.2794 10.408 19.8978 10.25 19.5 10.25H17.25L15.375 8Z",
    fill: "#863CFF",
    stroke: "#863CFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18C15.433 18 17 16.433 17 14.5C17 12.567 15.433 11 13.5 11C11.567 11 10 12.567 10 14.5C10 16.433 11.567 18 13.5 18Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.82c8a49916b0e43c13bdafb485952fe9.svg";
export { ForwardRef as ReactComponent };